import React from "react";
import { useEventContext } from "../../context";
import { useLocaleContext } from "../../context/LocaleContext";
import { services } from "@offline/components/SignIn/SocialLogin";
import AuthenticationBlock from "../../../platform/src/blocks/AuthenticationBlock";
import { getRegistrationFields } from "../../../platform/src/utils";

export const ClientLogin = ({ onLogin, onLogout }) => {
    const { event } = useEventContext();
    const $locale = useLocaleContext();

    if (!event) {
        return null;
    }

    const customDescription = $locale.getProperty(event.moduleAuth, 'customDescription')
        || $locale.getProperty(event.moduleSettings, 'loginSubtitle')
        ;

    return (
        <div style={{ padding: '0.5rem', background: '#b9b9b9' }}>
            <AuthenticationBlock
                eventKey={event.eventKey}
                eventName={$locale.getProperty(event, 'name')}
                eventPremoderation={event.moduleAuth.accessPreModeration}
                customDescription={customDescription}
                authRequired={event.moduleAuth.require}
                timeStart={event.timeStart}
                moduleSettings={event.moduleSettings}
                moduleAuth={event.moduleAuth}
                $locale={$locale}
                loginWithEmailEnabled={event.moduleAuth.email}
                loginWithNameEnabled={event.moduleAuth.guest}
                loginWithPhoneEnabled={event.moduleAuth.phone}
                externalServices={services.filter((name) => event.moduleAuth[name])}
                ssoIconUrl={event.moduleAuth.ssoIconUrl}
                registrationFields={getRegistrationFields(event, $locale.getProperty)}
                participationType={'online'}
                onLogin={(client) => client ? onLogin(client) : onLogout()}
                useVendorBranding={event.moduleBranding.showComdiBanner}
                corporateMail={event.moduleAuth.corporateMail ?? false}
                participationFormatLabels={event.moduleAuth.participationFormatLabels ?? []}
            />
        </div>
    );
}
